import React from 'react';
import Modal from 'components/new_ui/Modal/Modal';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function WaitPaymentProcess() {
  return (

    <Modal show>
      <LoadingPlaceholder text="Please wait while we process your payment" />
    </Modal>
  );
}
